import script from "./GithubLink.vue?vue&type=script&setup=true&lang=ts"
export * from "./GithubLink.vue?vue&type=script&setup=true&lang=ts"

import "./GithubLink.vue?vue&type=style&index=0&id=02b235a6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-02b235a6"]])

export default __exports__